/* ACCESSORY */
export const GET_ACCESSORY_LISTING = "GET_ACCESSORY_LISTING";
export const GET_ACCESSORY_LISTING_SUCCESS = "GET_ACCESSORY_LISTING_SUCCESS";
export const GET_ACCESSORY_LISTING_FAIL = "GET_ACCESSORY_LISTING_FAIL";

export const GET_ACCESSORY_DETAILS = "GET_ACCESSORY_DETAILS";
export const GET_ACCESSORY_DETAILS_SUCCESS = "GET_ACCESSORY_DETAILS_SUCCESS";
export const GET_ACCESSORY_DETAILS_FAIL = "GET_ACCESSORY_DETAILS_FAIL";

export const CREATE_ACCESSORY = "CREATE_ACCESSORY";
export const CREATE_ACCESSORY_SUCCESS = "CREATE_ACCESSORY_SUCCESS";
export const CREATE_ACCESSORY_FAIL = "CREATE_ACCESSORY_FAIL";

export const UPDATE_ACCESSORY = "UPDATE_ACCESSORY";
export const UPDATE_ACCESSORY_SUCCESS = "UPDATE_ACCESSORY_SUCCESS";
export const UPDATE_ACCESSORY_FAIL = "UPDATE_ACCESSORY_FAIL";

export const ADD_REMARK = "ADD_REMARK";
export const ADD_REMARK_SUCCESS = "ADD_REMARK_SUCCESS";
export const ADD_REMARK_FAIL = "ADD_REMARK_FAIL";

export const TOGGLE_FEATURE = "TOGGLE_FEATURE";
export const TOGGLE_FEATURE_SUCCESS = "TOGGLE_FEATURE_SUCCESS";
export const TOGGLE_FEATURE_FAIL = "TOGGLE_FEATURE_FAIL";

export const BULK_ACTION = "BULK_ACTION";
export const BULK_ACTION_SUCCESS = "BULK_ACTION_SUCCESS";
export const BULK_ACTION_FAIL = "BULK_ACTION_FAIL";

export const BULK_DELETE_ACCESSORY = "BULK_DELETE_ACCESSORY";
export const BULK_DELETE_ACCESSORY_SUCCESS = "BULK_DELETE_ACCESSORY_SUCCESS";
export const BULK_DELETE_ACCESSORY_FAIL = "BULK_DELETE_ACCESSORY_FAIL";

export const RESET_ACCESSORY_STATE = "RESET_ACCESSORY_STATE";
export const RESET_ACCESSORY_ACTION_STATE = "RESET_ACCESSORY_ACTION_STATE";